import { EMPTY } from '../constants';

import actions from '../actions';

function* listingSelected(reduction, id) {
  const state = reduction.get('photoEditor');
  const listing = state.getIn(['listings', 'byId', id]);

  function updatePhotos(photos) {
    return photos
      .set('changed', EMPTY.SET)
      .set('history', EMPTY.SET)
      .set('selected', photos.get('selected', photos.get('ids').last()));
  }

  return reduction.set('photoEditor',
    state
      .set('listing', listing.delete('photos'))
      .set('photos', listing.get('photos').update(updatePhotos))
  );
}

function* resetState(state) {
  return state.set('photoEditor', EMPTY.MAP);
}

function* setValue(reduction, { path, value }) {
  if (!path) return reduction;

  const fullPath = Array.isArray(path)
    ? ['photoEditor', ...path]
    : ['photoEditor', path];

  return value === undefined
    ? reduction.deleteIn(fullPath)
    : reduction.setIn(fullPath, value);
}

const photoEditor = {
  [actions.photoEditor.listingSelected]: listingSelected,
  [actions.photoEditor.resetState]: resetState,
  [actions.photoEditor.setValue]: setValue,
};

export default photoEditor;
